import { createPlayerPreference, usePlayerPreference } from './playerPreference';
import { useIsSleek } from '../theme';

/**
 * The player's own mute, kept in localStorage: the operator decides whether
 * the ceremony has sound and how loud (the library plays the score on those
 * settings); the player can still switch it off for themselves, and that
 * choice outlives the session.
 */
const mute = createPlayerPreference('gp_sound_muted');

export function isMuted(): boolean {
  return mute.get();
}

export function setMuted(next: boolean): void {
  mute.set(next);
}

export function useMuted(): boolean {
  const stored = usePlayerPreference(mute);
  const isSleek = useIsSleek();
  // Sleek's reveal has no mute switch to undo it with (partner mockup).
  return stored && !isSleek;
}

/** The player's mute as they set it, for a switch outside the reveal: the lab's own sounds follow it on every theme. */
export function usePlayerMuted(): boolean {
  return usePlayerPreference(mute);
}

/** Tests only. */
export function resetMutedForTests(): void {
  mute.reset();
}
